class VideoBanner {
  constructor(container) {
    this.container = container;

    this.isAnimating = false;
    this.slides = container.querySelectorAll('.js-video-slide');
    this.nav = container.querySelector('.js-video-nav');
    this.isMobile = window.matchMedia('(max-width: 991px)').matches;

    this.currentSlideLoop = 0;
    this.isCurrentVideoPlaying = false;
    this.nextSlideTimeout = null;

    if (!this.slides) {
      return;
    }

    if (this.nav) {
      this.navItems = this.nav.querySelectorAll('[data-index]');
      this.bindNav();
    }

    if (this.isMobile) {
      this.initMobileVideos();
    } else {
      this.initDesktopVideos();
    }

    Array.forEach(this.slides, slide => {
      this.bindPlayButton(slide);
      this.bindPauseButton(slide);
    });
  }

  getSlideById = id => {
    let targetSlide;

    Array.forEach(this.slides, slide => {
      const slideId = slide.getAttribute('data-index');
      if (slideId === id && !slide.classList.contains('active-in')) {
        targetSlide = slide;
      }
    });

    return targetSlide;
  };

  bindNav = () => {
    Array.forEach(this.navItems, item => {
      const id = item.getAttribute('data-index');
      const targetSlide = this.getSlideById(id);

      if (targetSlide !== null) {
        item.addEventListener('click', () => {
          this.resetCurrentSlideLoop();
          this.isCurrentVideoPlaying = false;
          this.setActiveItem(id);
        });
      }
    });
  };

  setActiveItem = id => {
    if (this.isAnimating) {
      return;
    }

    window.clearTimeout(this.nextSlideTimeout);

    const navItem = this.nav.querySelector(`[data-index="${id}"]:not(.active)`);
    const slide = this.getSlideById(id);
    const video = slide.querySelector('.js-video-player');

    if (video !== null) {
      this.updateVideo(video.src, slide);
    } else if (this.isCurrentVideoPlaying === false) {
      this.setNextActiveItem(slide, true);
    }

    if (navItem && slide) {
      this.clearActives();

      navItem.classList.add('active');
      slide.classList.add('active-in');
    }
  };

  setNextActiveItem = (slide, image = false) => {
    const maxIndex = this.navItems.length;
    let index = parseInt(slide.getAttribute('data-index'), 10) + 1;
    let delay = 0;

    if (index >= maxIndex) {
      index = 0;
    }

    if (image === true) {
      delay = 15000;
    }

    this.nextSlideTimeout = window.setTimeout(() => {
      this.setActiveItem(`${index}`);
    }, delay);
  };

  clearActives = () => {
    Array.forEach(this.slides, slide => {
      if (slide.classList.contains('active-in')) {
        slide.classList.remove('active-in');
        slide.classList.add('active-out');

        const video = slide.querySelector('.js-video-player');

        if (video !== null) {
          video.pause();
        }

        this.isAnimating = true;
        window.setTimeout(() => {
          this.isAnimating = false;
          slide.classList.remove('active-out');
          this.resetSlide(slide);
        }, 800);
      }
    });
    Array.forEach(this.navItems, item => item.classList.remove('active'));
  };

  bindPlayButton = slide => {
    const playVideoButton = slide.querySelector('.js-video-play');
    let src;
    if (playVideoButton === null) {
      return;
    }

    if (this.isMobile) {
      src = playVideoButton.getAttribute('data-mobile-src');
    } else {
      src = playVideoButton.getAttribute('data-src');
    }

    playVideoButton.addEventListener('click', () => {
      this.resetCurrentSlideLoop();
      this.isCurrentVideoPlaying = true;
      this.hideContent(slide);
      this.showVideoModal(src, slide);
    });
  };

  bindPauseButton = slide => {
    const pauseVideoButton = slide.querySelector('.js-video-modal-close');
    const video = slide.querySelector('.js-video-player');
    if (video === null || pauseVideoButton === null) {
      return;
    }

    pauseVideoButton.addEventListener('click', () => {
      this.resetCurrentSlideLoop();
      this.isCurrentVideoPlaying = false;
      const src = video.getAttribute('data-original-src');
      this.showContent(slide);
      this.hideVideoModal(src, slide);
    });
  };

  showContent(slide) {
    const videoContent = slide.querySelector('.js-video-content');

    videoContent.classList.add('active');
  }

  hideContent = slide => {
    const videoContent = slide.querySelector('.js-video-content');

    videoContent.classList.remove('active');
  };

  resetSlide(slide) {
    const videoContent = slide.querySelector('.js-video-content');

    if (videoContent !== null) {
      videoContent.classList.add('active');
    }

    const video = slide.querySelector('.js-video-player');

    if (video !== null) {
      const originalSrc = video.getAttribute('data-original-src');

      if (originalSrc !== video.src && originalSrc !== '' && originalSrc !== null) {
        video.src = originalSrc;
      }
    }
  }

  resetCurrentSlideLoop = () => {
    this.currentSlideLoop = 0;
  };

  hideVideoModal(src, slide) {
    const video = slide.querySelector('.js-video-modal');
    if (video === undefined || video === null) {
      return;
    }

    video.classList.add('fadeOutUpBig');
    video.classList.remove('fadeInUpBig');

    window.setTimeout(() => {
      video.classList.remove('active');
    }, 1000);

    const iframe = video.querySelector('.js-video-modal-iframe');

    iframe.src = iframe.src.replace('&amp;rel=0&amp;showinfo=0&amp;controls=1&amp;autoplay=1', '');

    this.nav.classList.remove('hidden');
  }

  showVideoModal(src, slide) {
    const video = slide.querySelector('.js-video-modal');
    if (video === undefined || video === null) {
      return;
    }

    video.classList.add('fadeInUpBig');
    video.classList.add('active');
    video.classList.remove('fadeOutUpBig');

    const iframe = video.querySelector('.js-video-modal-iframe');

    iframe.src = `${iframe.src}&amp;rel=0&amp;showinfo=0&amp;controls=1&amp;autoplay=1`;

    this.nav.classList.add('hidden');
  }

  updateVideo(src, slide, fadeTimeout = 500) {
    const video = slide.querySelector('.js-video-player');
    if (src === undefined || src === null) {
      return;
    }

    const originalSrc = video.src;

    if (!video.classList.contains('fade')) {
      video.classList.add('fade');
    }

    video.addEventListener('play', () => {
      window.setTimeout(() => video.classList.remove('fade'), fadeTimeout);
    });

    video.addEventListener('ended', () => {
      if (this.isCurrentVideoPlaying === true) {
        video.play();
        return;
      }

      this.currentSlideLoop += 1;
      if (this.currentSlideLoop > 1) {
        this.resetCurrentSlideLoop();

        this.setNextActiveItem(slide);
      } else {
        video.play();
      }
    });

    window.setTimeout(() => {
      video.setAttribute('src', src);
      video.setAttribute('data-original-src', originalSrc);
      video.play();
    }, 500);
  }

  initMobileVideos = () => {
    const slide = this.slides[0];

    const video = slide.querySelector('.js-video-player');
    if (video === null) {
      return;
    }

    const mobileSrc = video.getAttribute('data-mobile-src');
    if (mobileSrc === undefined || mobileSrc === null) {
      return;
    }

    this.updateVideo(mobileSrc, slide);
  };

  initDesktopVideos = () => {
    const slide = this.slides[0];
    if (slide === undefined || slide === null) {
      return;
    }

    const video = slide.querySelector('.js-video-player');
    if (video === null) {
      return;
    }

    const src = video.src;
    if (src === undefined || src === null) {
      return;
    }

    this.updateVideo(src, slide);
  };
}

const videoBanners = Array.from(document.querySelectorAll('.js-activity-video-banner'));

videoBanners.forEach(banner => {
  // eslint-disable-next-line
  new VideoBanner(banner);
});
